import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import FooterNav from 'desktop/components/layout/footer_nav'
import FooterReferralSection from 'desktop/components/layout/footer_referral_section'
import Link from 'base/react/components/link'

export class Footer extends Component {
  static propTypes = {
    referralUrl: PropTypes.string,
    isSignedIn: PropTypes.bool.isRequired,
    isCheckout: PropTypes.bool.isRequired,
    isSearch: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    referralUrl: '',
    isCheckout: false,
  }

  sitemapLinks = [
    { href: '/privacy', label: 'Privacy Policy' },
    { href: '/terms', label: 'Terms of Service' },
    {
      href: null,
      onClick: () => window.OneTrust?.ToggleInfoDisplay(),
      label: 'Do Not Sell My Personal Information',
    },
    { href: '/supply-chain', label: 'CA Supply Chain Transparency' },
    { href: '/vendor-code', label: 'Vendor Code of Conduct' },
    { href: '/sitemap', label: 'Sitemap Pages' },
    { href: '/sitemap/products', label: 'Sitemap Products' },
  ]

  render() {
    return this.props.isCheckout || this.props.isSearch ? null : this.renderFooter()
  }

  renderFooter() {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <FooterReferralSection
            isSignedIn={this.props.isSignedIn}
            referralUrl={this.props.referralUrl}
          />
          <FooterNav />
        </div>
        {this.renderFooterSitemap()}
      </footer>
    )
  }

  renderFooterSitemap() {
    const currentYear = new Date().getFullYear()

    return (
      <div className="footer-sitemap-container">
        <nav className="footer-sitemap">
          <ul className="horizontal">
            <li className="heading">&copy; {currentYear} All Rights Reserved</li>
            {this.renderSitemapLinks()}
          </ul>
        </nav>
      </div>
    )
  }

  renderSitemapLinks() {
    return (
      <React.Fragment>
        {this.sitemapLinks.map(linkObj => {
          return (
            <li key={linkObj.href || linkObj.id}>
              <Link
                onClick={linkObj.onClick}
                id={linkObj.id}
                href={linkObj.href}
                className="footer-sitemap-link"
              >
                {linkObj.label}
              </Link>
            </li>
          )
        })}
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    isSignedIn: !!state.session.user,
    referralUrl: state.session.user ? state.session.user.invite_url : '',
    isCheckout: window.location.pathname.includes('/checkout'),
    isSearch: window.location.pathname.includes('/search'),
  }
}

export default connect(mapStateToProps)(Footer)
